





























import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  data() {
    return {}
  },
  computed: {
    inIndex() {
      return this.$route.name === '__index'
    }
  }
})
